import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import {
  withStyles,
} from '@material-ui/core'
import {
  Add as AddIcon,
  CloudDownload as CloudDownloadIcon,
} from '@material-ui/icons'

import { LIST_TYPE, ROUTES } from '../constant'
import { getOrders } from '../actions/order'
import { navigate } from '../actions/app'
import Button from '../components/Button'
import Breadcrumb from '../components/Breadcrumb'
import ListAutomation from '../components/ListAutomation'


const styles = theme => ({
  root: {
    paddingTop: 0,
    padding: theme.spacing(1),
  },
})


class ListOrders extends Component {
  /* LIFECYCLE */


  /* METHODS */

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleItemClick = (item) => {
    this.props.history.push(`${ROUTES.ORDER}/${item.id}`)
  }

  handleNavigateCreateOrder = () => this.props.navigate(`${ROUTES.ORDER}/add`)


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      items,
      hasMore,
      classes,
      endBefore,
      isLoading,
      startAfter,
      hasPrevious,
    } = this.props

    return (
      <div className={classes.root}>
        <Breadcrumb
          data={[
            { label: 'Accueil', to: '/' },
            'Commandes',
          ]}
          actions={(
            <>
              <Button>
                <CloudDownloadIcon />&nbsp;&nbsp;Exporter{' '}
              </Button>
            </>
          )}
        />

        <ListAutomation
          items={items}
          hasMore={hasMore}
          endBefore={endBefore}
          startAfter={startAfter}
          hasPrevious={hasPrevious}
          isLoading={isLoading}
          title="Liste des commandes"
          onClick={this.handleItemClick}
          request={this.props.getOrders}
          head={['Client', 'montant', 'date', 'date d\'expiration', 'Numéro de facture', 'Choix de règlement', 'Frais technique', 'informations complémentaires']}
          row={item => ({
            primary: `${item.client ? item.client.name : 'N/A'} (${item.amount} €) - ${moment(item.created_at).format('DD/MM/YYYY')}`,
            data: [item.client && item.client.name, `${item.amount} €`, moment(item.created_at).format('DD/MM/YYYY'), moment(item.expires_at).format('DD/MM/YYY'), item.bill_number, item.payment_choice, item.technical_costs, item.informations],
          })}
        />

        <Button
          margin
          fullWidth
          color="primary"
          onClick={this.handleNavigateCreateOrder}
        >
          <AddIcon /> Créer{' '}
        </Button>
      </div>
    )
  }
}


ListOrders.propTypes = {
  hasMore: PropTypes.bool,
  hasPrevious: PropTypes.bool,
  endBefore: PropTypes.string,
  startAfter: PropTypes.string,
  navigate: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  getOrders: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  endBefore: state.list.endBefore,
  startAfter: state.list.startAfter,
  items: state.list.type === LIST_TYPE.ORDERS ? state.list.items : [],
  hasMore: state.list.type === LIST_TYPE.ORDERS ? state.list.hasMore : false,
  hasPrevious: state.list.type === LIST_TYPE.ORDERS ? state.list.hasPrevious : false,
})


export default connect(mapStateToProps, {
  navigate,
  getOrders,
})(withStyles(styles)(ListOrders))
